import { createFeatureSelector, createReducer, createSelector, on } from "@ngrx/store";
import { Message } from "src/app/common/messages";
import * as AppActions from './app.actions';

export interface mainState {
  messages: Message[];
  userInfo: any;
  error: string;
}

const initialMainState: mainState = {
  messages: [],
  userInfo: undefined,
  error: ''
};

export const appReducer = createReducer<mainState>(
  initialMainState,
  on(AppActions.addMessage, (state, action): mainState => {
    return {
      ...state,
      messages: [action.message,...state.messages]
    };
  }),
  on(AppActions.removeMessage, (state, action): mainState => {
    return {
      ...state,
      messages: state.messages.filter(m => m.id != action.message.id)
    };
  }),
  on(AppActions.loadFailure, (state, action): mainState => {
    return {
      ...state,
      error: action.error
    };
  }),
  on(AppActions.loadUserInfoSuccess, (state, action): mainState => {
    return {
      ...state,
      userInfo: action.userInfo
    };
  }),
);
